import { apiClient, isSupabaseConfigured } from './_shared.js'

/**
 * Транслитерация кириллицы → латиница для slug
 */
function transliterate(text) {
  const map = {
    'а':'a','б':'b','в':'v','г':'g','д':'d','е':'e','ё':'yo','ж':'zh','з':'z','и':'i',
    'й':'y','к':'k','л':'l','м':'m','н':'n','о':'o','п':'p','р':'r','с':'s','т':'t',
    'у':'u','ф':'f','х':'kh','ц':'ts','ч':'ch','ш':'sh','щ':'sch','ъ':'','ы':'y','ь':'',
    'э':'e','ю':'yu','я':'ya'
  }
  return text.toLowerCase().split('').map(c => map[c] || c).join('')
}

/**
 * Генерация URL-slug для вакансии
 */
function generateVacancySlug(title, pvzName = '') {
  const base = `${pvzName} ${title}`
    .replace(/[^a-zа-яё0-9\s]+/gi, '')
    .trim()
    .replace(/\s+/g, '-')
    .slice(0, 40)
  const hash = Math.random().toString(36).substring(2, 6)
  return `${transliterate(base)}-${hash}`
}

/**
 * Получить все вакансии организации
 */
export async function getVacancies(orgId) {
  if (!isSupabaseConfigured || !orgId) return []
  return await apiClient(`/vacancies?orgId=${orgId}`)
}

export async function getVacancy(id) {
  if (!isSupabaseConfigured) return null
  return await apiClient(`/vacancies/${id}`)
}

export async function createVacancy(orgId, vacancyData) {
  if (!isSupabaseConfigured) return null
  return await apiClient('/vacancies', {
    method: 'POST',
    body: JSON.stringify({ org_id: orgId, ...vacancyData })
  })
}

export async function updateVacancy(id, updates) {
  if (!isSupabaseConfigured) return null
  return await apiClient(`/vacancies/${id}`, {
    method: 'PUT',
    body: JSON.stringify(updates)
  })
}

export async function deleteVacancy(id) {
  if (!isSupabaseConfigured) return
  await apiClient(`/vacancies/${id}`, { method: 'DELETE' })
}

/**
 * Получить публичную вакансию по slug (через RPC, без авторизации)
 */
export async function getPublicVacancy(slug) {
  return await apiClient(`/vacancies/public/${slug}`)
}

export async function submitVacancyResponse(slug, responseData) {
  return await apiClient(`/vacancies/public/${slug}/respond`, {
    method: 'POST',
    body: JSON.stringify(responseData)
  })
}

export async function getPublicResponseStatus(id) {
  return await apiClient(`/vacancies/public/response/${id}`)
}

export async function getVacancyResponses(vacancyId) {
  if (!isSupabaseConfigured) return []
  return await apiClient(`/vacancies/${vacancyId}/responses`)
}

export async function updateVacancyResponse(id, updates) {
  if (!isSupabaseConfigured) return null
  return await apiClient(`/vacancies/responses/${id}`, {
    method: 'PUT',
    body: JSON.stringify(updates)
  })
}

export async function deleteVacancyResponse(id) {
  if (!isSupabaseConfigured) return
  await apiClient(`/vacancies/responses/${id}`, { method: 'DELETE' })
}

export async function getNewResponsesCount(orgId) {
  if (!isSupabaseConfigured || !orgId) return 0
  const data = await apiClient(`/vacancies/new-responses-count?orgId=${orgId}`)
  return data.count || 0
}

// ============================================
// AGGREGATORS (hh.ru, Авито)
// ============================================

export async function getAggregatorConnections(orgId) {
  try {
    const data = await apiClient(`/vacancies/aggregators/${orgId}`)
    return data || []
  } catch(e) {
    return []
  }
}

export async function disconnectAggregator(connectionId) {
  await apiClient(`/vacancies/aggregators/${connectionId}/disconnect`, { method: 'PUT' })
}

export async function deleteAggregatorConnection(connectionId) {
  await apiClient(`/vacancies/aggregators/${connectionId}`, { method: 'DELETE' })
}

export async function getVacancyExternalPosts(vacancyId) {
  try {
    const data = await apiClient(`/vacancies/${vacancyId}/external-posts`)
    return data || []
  } catch(e) {
    return []
  }
}
